export default __webpack_public_path__ + "static/automated-b8e345a5e4f5e498fcdc9b11b7ea0e7a.png";